import Schema from 'async-validator';
import errors from './errors';

export default {
    mixins: [errors],
    data() {
        return {
            rules: {},
            croppedStatus: {}
        }
    },
    methods: {
        validate(callback, form, scrollingDisabled = false, customRules = null) {
            (new Schema(customRules ?? this.rules)).validate(form, (errors, fields) => {
                if (errors) {
                    this.createErrorsValid(errors);

                    if (scrollingDisabled) {
                        return
                    }

                    setTimeout(() => {
                        const element = document.getElementById(
                            Object.keys(fields)[0]
                        );

                        if (!!element) {
                            element.scrollIntoView({block: "center", behavior: "smooth"});
                        }
                    }, 500)
                } else {
                    callback();
                }
            });
        },
        handlerCrop(property, value) {
            this.clearErrors();

            this.$set(this.croppedStatus, property, value);
        },
    }
}
